export class ModelTimeline {
  public open: boolean;
  public leftSpace: number;

  constructor(
    public hash: string,
    public startTime: number,
    public endTime: number,
    public execution: boolean,
    public preparation: boolean,
    public alarm: boolean,
    public stopped: boolean,
    public maintenance: boolean,
    public pause: boolean,
    public inactive: boolean
  ) { }

  toggleOpen() {
    this.open = !this.open;
  }

  clone() {
    return new ModelTimeline(
      this.hash,
      this.startTime,
      this.endTime,
      this.execution,
      this.preparation,
      this.alarm,
      this.stopped,
      this.maintenance,
      this.pause,
      this.inactive
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/summary/model-timeline.ts